export const visualNodeTypes = {
  event: 'event',
  delay: 'delay',
  experiment: 'experiment',
  experimentTreatment: 'experimentTreatment',
  count: 'count',
  countCondition: 'countCondition',
  condition: 'condition',
  collapsedCondition: 'collapsedCondition', // referring to the condition nodes merged by LHS
  action: 'action',
  actions: 'actions',
};
